import styled from 'styled-components';

const ButtonAreaStyled = styled.div`
  display: flex;
  gap: 10px;
  justify-content: flex-end;
  margin-top: 20px;
`;

export default function ButtonArea({ children }) {
  return <ButtonAreaStyled>{children}</ButtonAreaStyled>;
}